import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as StockTransferApiActions from "../actions/StockTransferApiActions";
import {
  showModalWindow,
  removeModalWindow,
} from "../actions/WindowActions";
import {Map} from "immutable";


function* requestCreateStockTransfer() {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreateStockTransferWindow", {}, "Create Stock Transfer"));
  yield take([StockTransferApiActions.CREATE_STOCK_TRANSFER.CANCEL, StockTransferApiActions.CREATE_STOCK_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreateStockTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_CREATE_STOCK_TRANSFER, requestCreateStockTransfer);
}

function* requestImportStockTransfer() {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ImportStockTransferWindow", {}, "Import Stock Transfer (already in transit)"));
  yield take([StockTransferApiActions.IMPORT_STOCK_TRANSFER.CANCEL, StockTransferApiActions.IMPORT_STOCK_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestImportStockTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_IMPORT_STOCK_TRANSFER, requestImportStockTransfer);
}

function* requestEditStockTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditStockTransferWindow", {transferId: baseAction.transferId}, "Edit Stock Transfer"));
  yield take([StockTransferApiActions.EDIT_STOCK_TRANSFER.CANCEL, StockTransferApiActions.EDIT_STOCK_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditStockTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_EDIT_STOCK_TRANSFER, requestEditStockTransfer);
}

function* requestAddPalletToTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddPalletToTransferWindow", {transferId: baseAction.transferId}, "Add Pallets"));
  yield take([StockTransferApiActions.ADD_PALLET_TO_TRANSFER.CANCEL, StockTransferApiActions.ADD_PALLET_TO_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddPalletToTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_ADD_PALLET_TO_TRANSFER, requestAddPalletToTransfer);
}

function* requestAddManualPalletToTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddManualPalletToTransferWindow", {transferId: baseAction.transferId}, "Add Manual Pallet", Map({width: "60vw"})));
  yield take([StockTransferApiActions.ADD_MANUAL_PALLET_TO_TRANSFER.CANCEL, StockTransferApiActions.ADD_MANUAL_PALLET_TO_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddManualPalletToTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_ADD_MANUAL_PALLET_TO_TRANSFER, requestAddManualPalletToTransfer);
}

function* requestRemovePalletFromTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemovePalletFromTransferWindow", {transferId: baseAction.transferId, palletId: baseAction.palletId}, "Remove Pallet"));
  yield take([StockTransferApiActions.REMOVE_PALLET_FROM_TRANSFER.CANCEL, StockTransferApiActions.REMOVE_PALLET_FROM_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemovePalletFromTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_REMOVE_PALLET_FROM_TRANSFER, requestRemovePalletFromTransfer);
}

function* requestDispatchStockTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "DispatchStockTransferWindow", {transferId: baseAction.transferId}, "Dispatch Stock Transfer"));
  yield take([StockTransferApiActions.DISPATCH_STOCK_TRANSFER.CANCEL, StockTransferApiActions.DISPATCH_STOCK_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestDispatchStockTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_DISPATCH_STOCK_TRANSFER, requestDispatchStockTransfer);
}

function* requestReceiveStockTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ReceiveStockTransferWindow", {transferId: baseAction.transferId}, "Receive Stock Transfer", Map({width: "60vw"})));
  yield take([StockTransferApiActions.RECEIVE_STOCK_TRANSFER.CANCEL, StockTransferApiActions.RECEIVE_STOCK_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestReceiveStockTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_RECEIVE_STOCK_TRANSFER, requestReceiveStockTransfer);
}

function* requestCancelStockTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CancelStockTransferWindow", {transferId: baseAction.transferId}, "Cancel Stock Transfer"));
  yield take([StockTransferApiActions.CANCEL_STOCK_TRANSFER.CANCEL, StockTransferApiActions.CANCEL_STOCK_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCancelStockTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_CANCEL_STOCK_TRANSFER, requestCancelStockTransfer);
}

function* requestDiscardStockTransfer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "DiscardStockTransferWindow", {transferId: baseAction.transferId}, "Delete Stock Transfer"));
  yield take([StockTransferApiActions.DISCARD_STOCK_TRANSFER.CANCEL, StockTransferApiActions.DISCARD_STOCK_TRANSFER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestDiscardStockTransfer() {
  yield takeLatest(StockTransferApiActions.REQUEST_DISCARD_STOCK_TRANSFER, requestDiscardStockTransfer);
}

export default function* saga() {
  yield fork(watchRequestCreateStockTransfer);
  yield fork(watchRequestImportStockTransfer);
  yield fork(watchRequestEditStockTransfer);
  yield fork(watchRequestAddPalletToTransfer);
  yield fork(watchRequestAddManualPalletToTransfer);
  yield fork(watchRequestRemovePalletFromTransfer);
  yield fork(watchRequestDispatchStockTransfer);
  yield fork(watchRequestReceiveStockTransfer);
  yield fork(watchRequestCancelStockTransfer);
  yield fork(watchRequestDiscardStockTransfer);
}
